module.exports = __webpack_public_path__ + "img/code.a0c1353c.jpg";